import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./skeleton.css";
import "./custom.css";

// import Arizona from "./components/Arizona";
import PimaTopBar from "./components/PimaTopBar";
import Arizona90 from "./components/Arizona90";
import Pima90 from "./components/Pima90";
import Pima from "./components/Pima";

export default class App extends Component {
  constructor() {
    super();
    this.state = {
      dailyDeaths: undefined,
      dailyPositive: undefined,
      currentHosp: undefined,
      dailyTests: undefined,
      tests: undefined,
      death: undefined,
      positive: undefined,
      newDates: undefined,
      currentDeath: undefined,
      currentPositive: undefined,
      currentTest: undefined,
      everHosp: undefined,
      dailyDMA: undefined,
      dailyTMA: undefined,
      dailyPMA: undefined,
      currentHMA: undefined,
      positiveMA: undefined,
      deathMA: undefined
    };
  }
  // DEFAULT: fetch("https://api.covidtracking.com/v1/states/az/daily.json")
  // Custom api: fetch("https://shugert-api-covid-az.herokuapp.com")
  componentWillMount() {
    fetch("https://api.covidtracking.com/v1/states/az/daily.json")
      .then((response) => response.json())
      .then((data) => {
        const dailyDeaths = data.map((a) => a.deathIncrease).reverse();
        console.log("dailyDeaths", dailyDeaths)
        const dailyPositive = data.map((a) => a.positiveIncrease).reverse();
        const currentHosp = data.map((a) => a.hospitalizedCurrently).reverse();
        const dailyTests = data
          .map((a) => a.totalTestResultsIncrease)
          .reverse();
        const tests = data.map((a) => a.totalTestResults).reverse();
        const dates = data.map((a) => a.date).reverse();
        const death = data.map((a) => a.death).reverse();
        const positive = data.map((a) => a.positive).reverse();
        let newDates = [];
        dates.forEach(function (date) {
          let oldDate = String(date);
          let year = oldDate.slice(0, 4);
          let month = oldDate.slice(4, 6);
          let day = oldDate.slice(6, 8);

          let newDate = `${day}/${month}/${year}`;

          newDates.push(newDate);
        });
        // newDates = newDates.reverse();
        function movingAvg(array, count, qualifier) {
          // calculate average for subarray
          var avg = function (array, qualifier) {
            var sum = 0,
              count = 0,
              val;
            for (var i in array) {
              val = array[i];
              if (!qualifier || qualifier(val)) {
                sum += val;
                count++;
              }
            }

            return sum / count;
          };

          var result = [],
            val;

          // pad beginning of result with null values
          for (var j = 0; j < count - 1; j++) result.push(null);

          // calculate average for each subarray and add to result
          for (var i = 0, len = array.length - count; i <= len; i++) {
            val = avg(array.slice(i, i + count), qualifier);
            if (isNaN(val)) result.push(null);
            else result.push(val);
          }

          return result;
        }
        const dailyDMA = movingAvg(dailyDeaths, 7);
        const dailyTMA = movingAvg(dailyTests, 7);
        const dailyPMA = movingAvg(dailyPositive, 7);
        const currentHMA = movingAvg(currentHosp, 7);
        const positiveMA = movingAvg(positive, 7);
        const deathMA = movingAvg(death, 7);
        this.setState({
          dailyDeaths: dailyDeaths,
          dailyPositive: dailyPositive,
          currentHosp: currentHosp,
          dailyTests: dailyTests,
          tests: tests,
          death: death,
          positive: positive,
          newDates: newDates,
          dailyDMA: dailyDMA,
          dailyTMA: dailyTMA,
          dailyPMA: dailyPMA,
          currentHMA: currentHMA,
          positiveMA: positiveMA,
          deathMA: deathMA,
        });
      }).catch(err => console.log(err));
  }
  render() {
    return (
      <Router>
        <div>
          <PimaTopBar />
          <Switch>
            <Route exact path="/" component={Pima} />
            <Route
              exact
              path="/arizona90"
              render={(props) => (
                <Arizona90
                  {...props}
                  dailyDeaths={this.state.dailyDeaths}
                  dailyPositive={this.state.dailyPositive}
                  currentHosp={this.state.currentHosp}
                  dailyTests={this.state.dailyTests}
                  tests={this.state.tests}
                  death={this.state.death}
                  positive={this.state.positive}
                  newDates={this.state.newDates}
                  dailyDMA={this.state.dailyDMA}
                  dailyTMA={this.state.dailyTMA}
                  dailyPMA={this.state.dailyPMA}
                  currentHMA={this.state.currentHMA}
                  positiveMA={this.state.positiveMA}
                  deathMA={this.state.deathMA}
                />
              )}
            />
            <Route exact path="/pima90" component={Pima90} />
          </Switch>
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js